module.exports = __webpack_public_path__ + "fasaw3.png?cdcd100e51159b8ac5b0333a3579f382";